<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="tab_modules"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class TabmodulesShow extends Vue {
  data = {}

  get columns() {
    return [
      ...createColumns(),
      {
        prop: 'action',
        label: '操作',
        edit: true
      }
    ]
  }

  async mounted() {
    this.data = await this.$request.get(`/tab_modules/${this.$route.params.id}`);
  }
}
</script>
